<template>
  <div>
    <div class="original-name">
      <span class="hint">{{ $t('Оригинал') }}</span>
      <div v-html="original"></div>
    </div>
    <span
      class="copy-icon"
      @click="copyText"
    ></span>
  </div>
</template>
<script>
export default {
  props: {
    original: {
      type: String
    }
  },
  methods: {
    // Копирование текста для мультиязычности
    copyText () {
      this.$emit('copyText', this.original)
    }
  }
}
</script>
